import classNames from "classnames";
import React from "react";
import { CHECK_SVG } from "../utils/svgs";
import { TASK_ICON } from "../utils/svgs_new";
import { withDefault } from "../utils/withDefault";
import { AppIcon } from "./Generic/AppIcon";

interface Props {
  size?: "medium" | "large";
  className?: string;
  color?: "primary" | "success" | "danger" | "white" | "black";
  variant?: "filled" | "outline" | "soft";
  isCompleted?: boolean;
}

const TaskAvatar = (props: Props) => {
  let defaultColor: "primary" | "success" = "primary";
  let defaultVariant: "filled" | "soft" = "filled";
  let icon: JSX.Element = TASK_ICON;
  let size: number | undefined;
  if (props.isCompleted === true) {
    defaultColor = "success";
    defaultVariant = "soft";
    icon = CHECK_SVG;
    size = 12;
  }
  return (
    <div
      className={classNames("TaskAvatar", props.size, props.className)}
      data-task-avatar-color={withDefault(props.color, defaultColor)}
      data-task-avatar-variant={withDefault(props.variant, defaultVariant)}
    >
      <AppIcon icon={icon} size={size} />
    </div>
  );
};

export default TaskAvatar;
